import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { ObjectiveFlag, AddButton } from '_components';
import styles from './Common.module.css'
import { ObservationAccJointMobEntry } from './ObservationAccJointMobEntry';

class ObservationAccJointMobBodyRegion extends React.Component {

    addMob() {
        this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEACCJOINTMOB', 'JM', 'JMOONO', this.props.oono);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.mobEntries.length > 0} mopno={this.props.mopno} flagText='Accessory Joint Mobility' />
                    <div className={styles.add_button} >
                        <AddButton title='Add Joint Mobility Entry...' size='extra-small' onClick={() => this.addMob()} />
                    </div>
                    {this.props.mobEntries.length === 0 &&
                        <div className={styles.tip}>Click to add entry</div>
                    }
                    {this.props.mobEntries.length > 0 &&
                        <span>
                            <div className={styles.mob_column_1_header}>Joint</div>
                            <div className={styles.mob_column_2_header}>Side</div>
                            <div className={styles.mob_column_3_header}>Plane of Motion</div>
                            <div className={styles.mob_column_4_header}>End Feel</div>
                        </span>
                    }
                </div>
                {Object.keys(this.props.mobEntries)
                    .map(key => {
                        const result = this.props.mobEntries[key];
                        return (
                            <ObservationAccJointMobEntry key={result.JMNO} id={result.JMNO} />
                        )
                    })
                }

            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        noteId: noteId,
        oono: oono,
        asno: asno,
        mobEntries: Object.keys(state.entities.notes.PTOBJECTIVEACCJOINTMOB)
            .filter(key => { return state.entities.notes.PTOBJECTIVEACCJOINTMOB[key].JMOONO === oono })
            .sort((a, b) => state.entities.notes.PTOBJECTIVEACCJOINTMOB[a].JMNO - state.entities.notes.PTOBJECTIVEACCJOINTMOB[b].JMNO)
            .map(key => state.entities.notes.PTOBJECTIVEACCJOINTMOB[key]),
        objUpdated
    };
}


const connectedObservationAccJointMobBodyRegion = connect(mapStateToProps, mapDispatchToProps)(ObservationAccJointMobBodyRegion);
export { connectedObservationAccJointMobBodyRegion as ObservationAccJointMobBodyRegion };


